export const basciUrl = 'https://kpi.taskwinone.com'